import { c as _c } from "react/compiler-runtime";
import "client-only";
import { useState } from "react";
import type { CommentModel } from "@/services/api/comment/models/comment.model.types";
import { commentConfig } from "../config/comment.config";
type ThreadInput = {
  readonly comment: CommentModel;
  readonly depth: number;
};
export type UseCommentThreadApi = {
  readonly ancestorId: string | null;
  readonly showReplies: boolean;
  readonly isReplying: boolean;
  readonly openReplyForm: () => void;
  readonly closeReplyForm: () => void;
  readonly isRepliesExpanded: boolean;
  readonly toggleRepliesExpanded: () => void;
};
export function useCommentThread(t0) {
  const $ = _c(8);
  const {
    comment,
    depth
  } = t0;
  const isAtMaxDepth = depth >= commentConfig.maxDepth;
  const shouldStartCollapsed = depth >= commentConfig.collapseRepliesFromDepth;
  const [isReplying, setIsReplying] = useState(false);
  const [isRepliesExpanded, setIsRepliesExpanded] = useState(!shouldStartCollapsed);
  const hasReplies = comment.replies.comments.length > 0 || comment.replies.hasNextPage;
  const t1 = isAtMaxDepth ? comment.parentId : null;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsReplying(false);
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsReplying(true);
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = !isAtMaxDepth && hasReplies;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setIsRepliesExpanded(_temp);
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== isRepliesExpanded || $[4] !== isReplying || $[5] !== t1 || $[6] !== t4) {
    t6 = {
      ancestorId: t1,
      closeReplyForm: t2,
      isRepliesExpanded,
      isReplying,
      openReplyForm: t3,
      showReplies: t4,
      toggleRepliesExpanded: t5
    };
    $[3] = isRepliesExpanded;
    $[4] = isReplying;
    $[5] = t1;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
}
function _temp(prev) {
  return !prev;
}